var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "is-flex is-flex-direction-column is-justify-content-space-between is-align-content-center",
      attrs: { id: "home" },
    },
    [
      _c("section", [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("img", {
              staticClass: "image is-centered mt-5",
              attrs: { src: "/statics/signar-logo-grey.svg", alt: "" },
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("buscador", {
              attrs: { active: _vm.buscadorActive },
              on: {
                "update:active": function ($event) {
                  _vm.buscadorActive = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.$store.getters.hasAnyRole(["user", "lyris"])
        ? _c("recent-docs")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }